import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import React from 'react'
import './reset.css'
import Home from './View/Home/Home.js'
import Navbar from "./View/Navbar/Navbar";
import Team from "./View/Team/Team";
import Contact from "./View/Contact/Contact"
import Footer from "./View/Footer/Footer";
import Training from "./View/Training/Training";
import News from "./View/News/News";

function App() {
  return (
      <Router>
        <div className="App">
            <Navbar/>
            <Switch>
                <Route exact path = "/" >
                    <Home/>
                </Route>
                <Route path = "/team">
                    <Team/>
                </Route>
                <Route path = "/training">
                    <Training/>
                </Route>
                <Route path = "/news">
                    <News/>
                </Route>
                <Route path = "/contact">
                    <Contact/>
                </Route>

                <Route path = "/*">
                    <Home/>
                </Route>
            </Switch>
            <Footer/>
        </div>
      </Router>
  );
}

export default App;
